export const NAME = 'site';

export const STAGING_OVERRIDE_PATH = 'staging.overrides';
export const DELETION_MARK = Symbol();
